import { useState } from "react";

export default function FaqItem({ question, answer }) {
    const [open, setOpen] = useState(false);

    return (
        <div className="border-b border-[hsl(var(--tm-hairline))]">
            <button
                onClick={() => setOpen(!open)}
                className="w-full flex items-start justify-between gap-6 py-6 text-left group"
                aria-expanded={open}
            >
                <span className="tm-serif text-lg sm:text-xl text-[hsl(var(--tm-anthracite))] group-hover:text-[hsl(var(--tm-gold))] transition-colors duration-300">
                    {question}
                </span>
                <span
                    className="shrink-0 mt-1 w-5 h-5 relative"
                    aria-hidden="true"
                >
                    <span className="absolute top-1/2 left-0 w-5 h-px bg-[hsl(var(--tm-gold))]"></span>
                    <span
                        className="absolute top-1/2 left-0 w-5 h-px bg-[hsl(var(--tm-gold))] transition-transform duration-400"
                        style={{ transform: open ? "rotate(0deg)" : "rotate(90deg)" }}
                    ></span>
                </span>
            </button>
            <div
                className="overflow-hidden transition-all duration-500 ease-out"
                style={{ maxHeight: open ? "400px" : "0px", opacity: open ? 1 : 0 }}
            >
                <p className="pb-6 pr-10 text-[hsl(var(--tm-anthracite-soft))] leading-relaxed">
                    {answer}
                </p>
            </div>
        </div>
    );
}
